import { RouteDefinition } from "@solidjs/router";
import { GModTest } from "./pages/GmodTest.jsx";

export const gmodRoutes: RouteDefinition[] = [
  {
    path: "/",
    component: GModTest,
  },
];
